import { render, staticRenderFns } from "./list_users_admin_component.vue?vue&type=template&id=edd08442&scoped=true"
import script from "./list_users_admin_component.vue?vue&type=script&lang=js"
export * from "./list_users_admin_component.vue?vue&type=script&lang=js"
import style0 from "./list_users_admin_component.vue?vue&type=style&index=0&id=edd08442&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd08442",
  null
  
)

export default component.exports